import { render, staticRenderFns } from "./MerchantsDetails.vue?vue&type=template&id=9069ecb6"
import script from "./MerchantsDetails.vue?vue&type=script&lang=js"
export * from "./MerchantsDetails.vue?vue&type=script&lang=js"
import style0 from "./MerchantsDetails.vue?vue&type=style&index=0&id=9069ecb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports